import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Assuming you have basic CSS
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig"; // Your config file

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
);